import {useMemo} from "react";

export const DOTS = '...';

const range = (start, end) => {
    let length = end - start + 1;
    return Array.from({length}, (_, idx) => idx + start);
};

const ensureLastPageVisible = (pages, totalPageCount) => {
    if (!pages?.length || totalPageCount <= 1 || pages.includes(totalPageCount)) {
        return pages || range(1, Math.max(totalPageCount, 1));
    }

    const lastItem = pages[pages.length - 1];
    if (lastItem === DOTS) {
        return [...pages, totalPageCount];
    }

    return [...pages, DOTS, totalPageCount];
};

export const usePagination = ({
                                  totalCount,
                                  pageSize,
                                  siblingCount = 1,
                                  currentPage
                              }) => {
    return useMemo(() => {
        const totalPageCount = Math.ceil(totalCount / pageSize);

        if (!totalPageCount) {
            return [];
        }

        const totalPageNumbers = siblingCount + 5;

        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }

        const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(
            currentPage + siblingCount,
            totalPageCount
        );

        const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;

        let paginationRange;

        if (!shouldShowLeftDots && shouldShowRightDots) {
            let leftItemCount = 3 + 2 * siblingCount;
            let leftRange = range(1, leftItemCount);

            paginationRange = [...leftRange, DOTS, totalPageCount];
        } else if (shouldShowLeftDots && !shouldShowRightDots) {
            let rightItemCount = 3 + 2 * siblingCount;
            let rightRange = range(
                totalPageCount - rightItemCount + 1,
                totalPageCount
            );
            paginationRange = [firstPageIndex, DOTS, ...rightRange];
        } else if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = range(leftSiblingIndex, rightSiblingIndex);
            paginationRange = [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
        } else {
            paginationRange = range(1, totalPageCount);
        }

        return ensureLastPageVisible(paginationRange, totalPageCount);
    }, [totalCount, pageSize, siblingCount, currentPage]);
};
